import { Component, Input } from '@angular/core';
import { OktaAuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent {

  @Input() opened = false;
  constructor(private okta: OktaAuthService, private router: Router) { }

isActive(route: string): boolean {
  const current = this.router.url;
  console.log(`Checking route: ${route} === ${current}`);
  return current === route;
}


  ngOnInit() { }
  isUserAuthorized(page:string)
  {
    return this.okta.isUserAuthorized(page)  }

  
}